import { TaggedError } from "@for-it/domain-lib";
export class InvalidSubdomainError extends TaggedError {
    subdomain;
    constructor(subdomain) {
        super("InvalidSubdomainError");
        this.subdomain = subdomain;
    }
}
